module.exports = __webpack_public_path__ + "img/guide-ko-2.c21f922b.png";